export const preventPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
};
